import createLucideIcon from '../createLucideIcon';

const Clock9 = createLucideIcon('Clock9Icon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 7.5 12', key: '1k60p0' }],
]);

export default Clock9;
